<div class="thank-you">
  Thank you for your order!
</div>
